export const EVENTS = {
  WALLET: {
    REFRESH: 'wallet.refresh',
    REFRESHING: 'wallet.refreshing',
    REFRESH_ERROR: 'wallet.error',
    REFRESHED: 'wallet.refreshed'
  }
};
export const ENDPOINTS = {
  WALLET: {
    GET: '/wallet/balance/{userId}?service=kingrecharges-customer&country=BJ&processor=kingrecharges-customer&currency=XOF&group=kingrecharges'
  }
};
